import { useMutation, useQueryClient } from "@tanstack/vue-query";
import CallLog from "@/services/call-log";
import { RegisterCallLog, EditCallLog } from "@/dtos/CallLog.dto";

export function useRegisterCallLog() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (callLog: RegisterCallLog) => {
      const result = await CallLog.registerCallLog(callLog);
      if (result.data.status) {
        return result.data.data;
      }
      throw new Error(result.data.msg || "Failed to register call log");
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["callLogs"] });
      queryClient.invalidateQueries({ queryKey: ["contact", variables.contactId] });
    },
  });
}

export function useLogCallLogDetails() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (callLogDetails: EditCallLog) => {
      const result = await CallLog.logCallLogDetails(callLogDetails);
      if (result.data.status) {
        return result.data.data;
      }
      throw new Error(result.data.msg || "Failed to log call details");
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["callLogs"] });
      if (variables.callSid) {
        queryClient.invalidateQueries({ queryKey: ["callLog", variables.callSid] });
      }
    },
  });
}
